import { render } from "./Fax.vue?vue&type=template&id=3502ec88"
import script from "./Fax.vue?vue&type=script&lang=js"
export * from "./Fax.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__